export default __webpack_public_path__ + "static/media/0700BLEU.fb3f0dc7.pdf";